// Auto-generated index file for all skeletons

import { Account } from "./Account";
import { AccountBalance } from "./AccountBalance";
import { AccountName } from "./AccountName";
import { AccountingYear } from "./AccountingYear";
import { Address } from "./Address";
import { Building } from "./Building";
import { BuildingGroup } from "./BuildingGroup";
import { BuildingType } from "./BuildingType";
import { Changelog } from "./Changelog";
import { Cis } from "./Cis";
import { CisType } from "./CisType";
import { ClientDatabase } from "./ClientDatabase";
import { ClientUnitQuota } from "./ClientUnitQuota";
import { Comment } from "./Comment";
import { Contact } from "./Contact";
import { CraftsmanTask } from "./CraftsmanTask";
import { CraftsmanTaskPerson } from "./CraftsmanTaskPerson";
import { CraftsmanTaskPersonContact } from "./CraftsmanTaskPersonContact";
import { CraftsmanTaskPersonType } from "./CraftsmanTaskPersonType";
import { CraftsmanTaskProcess } from "./CraftsmanTaskProcess";
import { CraftsmanTaskStatus } from "./CraftsmanTaskStatus";
import { CraftsmanTaskStatusText } from "./CraftsmanTaskStatusText";
import { CraftsmanTaskType } from "./CraftsmanTaskType";
import { Document } from "./Document";
import { DocumentContainer } from "./DocumentContainer";
import { DocumentType } from "./DocumentType";
import { Email } from "./Email";
import { EmailRecipient } from "./EmailRecipient";
import { Faq } from "./Faq";
import { History } from "./History";
import { Image } from "./Image";
import { Invoice } from "./Invoice";
import { Journal } from "./Journal";
import { JournalReview } from "./JournalReview";
import { MailTemplate } from "./MailTemplate";
import { Message } from "./Message";
import { Note } from "./Note";
import { Notification } from "./Notification";
import { Person } from "./Person";
import { PersonUpdateRequest } from "./PersonUpdateRequest";
import { PhoneNumber } from "./PhoneNumber";
import { Priority } from "./Priority";
import { Privacy } from "./Privacy";
import { PropertyManager } from "./PropertyManager";
import { ReadBy } from "./ReadBy";
import { Record } from "./Record";
import { RecordStatus } from "./RecordStatus";
import { Report } from "./Report";
import { ReportStatus } from "./ReportStatus";
import { ReportSubType } from "./ReportSubType";
import { ReportType } from "./ReportType";
import { ReviewDocument } from "./ReviewDocument";
import { ReviewDocumentReviewer } from "./ReviewDocumentReviewer";
import { Revision } from "./Revision";
import { Role } from "./Role";
import { RolePermission } from "./RolePermission";
import { SourceResource } from "./SourceResource";
import { Subscription } from "./Subscription";
import { Sync } from "./Sync";
import { Task } from "./Task";
import { TaskType } from "./TaskType";
import { Team } from "./Team";
import { Ticket } from "./Ticket";
import { TicketType } from "./TicketType";
import { Tos } from "./Tos";
import { Unit } from "./Unit";
import { User } from "./User";
import { VendorAccount } from "./VendorAccount";

export const Skeletons = {
  Account,
  AccountBalance,
  AccountName,
  AccountingYear,
  Address,
  Building,
  BuildingGroup,
  BuildingType,
  Changelog,
  Cis,
  CisType,
  ClientDatabase,
  ClientUnitQuota,
  Comment,
  Contact,
  CraftsmanTask,
  CraftsmanTaskPerson,
  CraftsmanTaskPersonContact,
  CraftsmanTaskPersonType,
  CraftsmanTaskProcess,
  CraftsmanTaskStatus,
  CraftsmanTaskStatusText,
  CraftsmanTaskType,
  Document,
  DocumentContainer,
  DocumentType,
  Email,
  EmailRecipient,
  Faq,
  History,
  Image,
  Invoice,
  Journal,
  JournalReview,
  MailTemplate,
  Message,
  Note,
  Notification,
  Person,
  PersonUpdateRequest,
  PhoneNumber,
  Priority,
  Privacy,
  PropertyManager,
  ReadBy,
  Record,
  RecordStatus,
  Report,
  ReportStatus,
  ReportSubType,
  ReportType,
  ReviewDocument,
  ReviewDocumentReviewer,
  Revision,
  Role,
  RolePermission,
  SourceResource,
  Subscription,
  Sync,
  Task,
  TaskType,
  Team,
  Ticket,
  TicketType,
  Tos,
  Unit,
  User,
  VendorAccount,
};

